<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select class="select_btn_style" v-model="filters.classUserType" placeholder="人员角色">
        <el-option v-for="(item, i) in classUserTypeData" :key="i" :label="item.paramValue"
          :value="item.paramKey"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select class="select_btn_style" v-model="filters.clockStatus" placeholder="报到状态">
        <el-option v-for="(item, i) in clockStatusData" :key="i" :label="item.paramValue"
          :value="item.paramKey"></el-option>
      </el-select>
    </el-form-item>
    <!-- <el-form-item class="select_btn">
      <el-select class="select_btn_style" v-model="filters.roomStatus" placeholder="分房状态">
        <el-option v-for="(item, i) in roomStatusData" :key="i" :label="item.paramValue"
          :value="item.paramKey"></el-option>
      </el-select>
    </el-form-item> -->
    <el-form-item class="m-l-14">
      <el-input prefix-icon="el-icon-search" size="small" v-model.trim="filters.nameOrRoom"
        placeholder="姓名/房间号"></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="query"></butn>
      <butn title="重置" @click="reset" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getEnums } from "@/utils/common.js";
export default {
  props: {},
  components: { butn },
  data() {
    return {
      filters: {
        classUserType: null,
        clockStatus: null,
        roomStatus: null,
        nameOrRoom: '',
      },
      classUserTypeData: [],
      clockStatusData: [],
      roomStatusData: [],
    };
  },
  created() {
    getEnums(['CLASS_USER_TYPE', 'CLOCK_STATUS', 'IS_DEFAULT'], this, ['classUserTypeData', 'clockStatusData', 'roomStatusData'], [true, true, true])
  },
  methods: {
    query() {
      this.$emit("search", this.filters);
    },
    reset() {
      this.filters = {
        classUserType: null,
        clockStatus: null,
        roomStatus: null,
        nameOrRoom: '',
      };
      this.query();
    },
  }
}
</script>
<style lang='scss' scoped>

</style>